'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faExpand } from '@awesome.me/kit-94e593bf23/icons/sharp/thin';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
const VariantImageViewer = t0 => {
  const $ = _c(26);
  const {
    variant,
    productName: t1
  } = t0;
  const productName = t1 === undefined ? "Product" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(_temp, t2);
  const [isOpen, setIsOpen] = useState(false);
  if (false || !variant || !variant.file_name) {
    return null;
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeModal = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(true);
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-xs text-light"><FontAwesomeIcon icon={faExpand} className="mr-1" />Enlarge</div>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${variant.file_name}`;
  const t7 = `${productName} variant`;
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = <div className="flex justify-end items-center mb-2 lg:hidden"><button className="flex items-center gap-2 cursor-pointer" onClick={t4} aria-label="View variant image">{t5}<div className="max-w-[80px] max-h-[80px]"><Image className="w-auto h-auto max-w-full max-h-full object-contain" src={t6} alt={t7} quality={90} width={250} height={250} /></div></button></div>;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = `${productName} variant image`;
  let t10;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <button onClick={closeModal} className="absolute top-2 right-2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 rounded-full hover:bg-white transition-colors" aria-label="Close"><FontAwesomeIcon icon={faXmark} className="text-lg" /></button>;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${variant.file_name}`;
  const t12 = `${productName} variant`;
  let t13;
  if ($[8] !== t11 || $[9] !== t12) {
    t13 = <div className="shadow-sm p-3 aspect-square flex items-center justify-center"><Image src={t11} alt={t12} quality={90} width={800} height={800} className="max-w-full max-h-full object-contain" /></div>;
    $[8] = t11;
    $[9] = t12;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  const t14 = variant.description || variant.variant_description || productName;
  let t15;
  if ($[11] !== t14) {
    t15 = <div className="text-left"><div className="font-medium text-sm capitalize">{t14}</div></div>;
    $[11] = t14;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-2xl" />;
    $[13] = t16;
  } else {
    t16 = $[13];
  }
  let t17;
  if ($[14] !== t15) {
    t17 = <div className="mt-3 flex items-end justify-between gap-4">{t15}{t16}</div>;
    $[14] = t15;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] !== t13 || $[17] !== t17) {
    t18 = <div className="p-4">{t13}{t17}</div>;
    $[16] = t13;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== isOpen || $[20] !== t18 || $[21] !== t9) {
    t19 = <Modal isOpen={isOpen} onRequestClose={closeModal} contentLabel={t9} overlayClassName="fixed inset-0 z-[1000] flex items-center justify-center bg-modal-overlay p-4" className="relative bg-white rounded-lg max-w-[90vw] max-h-[90vh] overflow-hidden outline-none">{t10}{t18}</Modal>;
    $[19] = isOpen;
    $[20] = t18;
    $[21] = t9;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t19 || $[24] !== t8) {
    t20 = <>{t8}{t19}</>;
    $[23] = t19;
    $[24] = t8;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  return t20;
};
export default VariantImageViewer;
function _temp() {
  Modal.setAppElement("#app");
}